import { useEffect, useRef } from 'react';
import { useLocation, Outlet, Navigate, useMatch } from 'react-router';
import { useAuth } from '@/shared/auth';
import { useRecordLoginEvent } from '@/shared/api/generated/users';

export const AuthRouteGuard = () => {
  const { sessionUser: user } = useAuth();
  const { mutate: recordLoginEvent } = useRecordLoginEvent();
  const hasRecordedLogin = useRef(false);

  const isLoginPage = useMatch('/login');
  const isSignupPage = useMatch('/signup');

  const location = useLocation();

  const isPublicRoute =
    location.pathname.startsWith('/public/') ||
    location.pathname.startsWith('/book/') ||
    location.pathname.startsWith('/pay/') ||
    location.pathname.startsWith('/invite/') ||
    location.pathname === '/forgot-password' ||
    location.pathname === '/reset-password';

  useEffect(() => {
    if (user && !hasRecordedLogin.current) {
      hasRecordedLogin.current = true;
      recordLoginEvent(undefined, {
        onError: () => {
          // Fire-and-forget — login recording failure should not affect the user
        },
      });
    }
  }, [user, recordLoginEvent]);

  if (!user && !isPublicRoute && !(isLoginPage || isSignupPage)) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};
